import dayjs from "dayjs";
import "dayjs/locale/es";

export const getExpressiveDate = (dateToFormat: Date): string => {
  const date = new Date(dateToFormat);
  const dateOptions: Object = {
    month: "short",
    day: "2-digit",
    year: "numeric",
  };
  const monthsInSpanish: string[] = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];

  const formattedDate = date.toLocaleDateString("es-ES", dateOptions);
  const [day, month, year] = formattedDate.split(" ");

  // Getting the month abbreviation with the first letter capitalized
  const monthAbbreviation = monthsInSpanish.find(
    (m) => m.toLowerCase() === month.toLowerCase()
  );

  // Returning the date in the desired format
  return `${day} ${monthAbbreviation} ${year}`;
};

export const getFormalDate = (dateToFormat: Date) => {
  const date = new Date(dateToFormat);

  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

  const month =
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth();

  return `${day}/${month}/${date.getFullYear()}`;
};

export const getExpressiveTime = (timeToFormat: Date): string => {
  const time = new Date(timeToFormat);
  const hour = time.getHours();
  const minute = time.getMinutes();

  return `${hour}:${minute < 10 ? "0" : ""}${minute}`;
};

export const getMonthName = (monthNumber: number) => {
  return dayjs()
    .locale("es")
    .month(monthNumber - 1)
    .format("MMMM");
};
